import moment from 'moment-timezone';

import {hasValue} from 'web-app/util/typescript';

export enum SortDirection {
    ASC = 'ASC',
    DSC = 'DSC',
}

export const sortByString = (a: string, b: string, direction: SortDirection = SortDirection.ASC) => {
    const result = a.localeCompare(b);

    return direction === SortDirection.ASC ? result : result * -1;
};

export const sortByDate = (
    a: string | undefined,
    b: string | undefined,
    direction: SortDirection,
    aFallback: string,
    bFallback: string,
) => {
    const aIsSameAsB = moment(a).isSame(b, 'day');
    if (aIsSameAsB) {
        return sortByString(aFallback, bFallback, direction);
    } else if (direction === SortDirection.DSC) {
        if (!hasValue(a)) {
            return 1;
        }
        if (!hasValue(b)) {
            return -1;
        }
        return moment(a).isAfter(b, 'day') ? -1 : 1;
    } else {
        if (!hasValue(a)) {
            return -1;
        }
        if (!hasValue(b)) {
            return 1;
        }
        return moment(a).isAfter(b, 'day') ? 1 : -1;
    }
};

export const sortByDateTime = (a: string, b: string, direction: SortDirection = SortDirection.DSC) => {
    if (direction === SortDirection.DSC) {
        return moment(a).isAfter(b) ? -1 : 1;
    } else {
        return moment(a).isAfter(b) ? 1 : -1;
    }
};

export const sortByComparison =
    <P>(direction: SortDirection) =>
    (a: P, b: P): -1 | 0 | 1 => {
        const ascSortOrder = a > b ? 1 : -1;

        if (direction === SortDirection.DSC) {
            return (ascSortOrder * -1) as -1 | 1;
        }

        return ascSortOrder;
    };

export const flipDirection = (direction: SortDirection) =>
    direction === SortDirection.ASC ? SortDirection.DSC : SortDirection.ASC;
